import { render, staticRenderFns } from "./WorkgroupPicker.vue?vue&type=template&id=45aeccff&"
import script from "./WorkgroupPicker.vue?vue&type=script&lang=ts&"
export * from "./WorkgroupPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports